import {AccordionExpandedEnum} from '../../../types';

export const OFFSETS_TO_SCROLL = {
	[AccordionExpandedEnum.PATIENT_DATA]: {tablet: 71, desktop: 103},
	[AccordionExpandedEnum.FISCAL_DOCUMENT]: {tablet: 142, desktop: 174},
};
